<template>
  <el-dialog
    :title="$t('btn.Borrowing')"
    :visible.sync="dialogVisible"
    width="1200px"
    class="loanDialog"
    @close="dialogCloseHandle"
  >
    <el-form
      class="common_form"
      label-position="left"
      ref="loanDialogForm"
      :rules="rules"
      label-width="180px"
      :model="formData"
    >
      <el-row>
        <el-col :span="12">
          <el-form-item :label="$t('newApp.Attribute.aoe')" prop="deptName">
            <el-input :disabled="true" v-model="formData.deptName" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('newApp.Attribute.toe')" prop="expenseType">
            <el-input :disabled="true" v-model="formData.expenseType" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item :label="$t('eventList.LoanAmount')" prop="borrowMoney">
            <el-input v-model="formData.borrowMoney" maxlength="10" @input="moneyFileter" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('eventList.PaymentDate')" prop="loanInfo.utilityTime">
            <el-date-picker
              value-format="yyyy-MM-dd"
              type="date"
              :placeholder="$t('general.psad')"
              v-model="formData.loanInfo.utilityTime"
              @change="clickUseDate"
              :picker-options="pickerOptions"
              style="width: 100%;"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item :label="$t('eventList.RepaymentDate')" prop="loanInfo.repaymentTime">
            <el-input :disabled="true" v-model="formData.loanInfo.repaymentTime" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('eventList.ContractNumber')" prop="contractNo">
            <el-input v-model="formData.contractNo" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item :label="$t('eventList.Dotuof')" prop="borrowPurpose">
            <el-input type="textarea" v-model="formData.borrowPurpose" />
          </el-form-item>
        </el-col>
      </el-row>
      <div class="danger">{{$t('eventList.Tdpiii')}}{{ formData.annualInterest }}</div>
      <div class="title">{{$t('eventList.ReceiptInfo')}}</div>
      <el-row>
        <el-col :span="12">
          <el-form-item :label="$t('eventList.Mop')" prop="payType">
            <el-input :disabled="true" v-model="formData.payType" />
            <!--            <el-select :disabled="true" v-model="formData.payType" placeholder="请选择">-->
            <!--              <el-option v-for="item in payTypeList" :key="item.id" :label="item.typeName" :value="item.typeName" />-->
            <!--            </el-select>-->
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('eventList.AccountType')" prop="accountType">
            <el-select v-model="formData.accountType" :placeholder="$t('general.ps')">
              <el-option
                v-for="item in accountTypeList"
                :key="item.id"
                :label="item.typeName"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item :label="$t('eventList.ReceivingUnit')" prop="bankAccount">
            <el-select
              filterable
              remote
              reserve-keyword
              v-model="formData.bankAccount"
              :loading="loading"
              :placeholder="$t('eventList.Pepnopn')"
              :remote-method="getFinancialAccountByKey"
              @change="receiptInstitutionChange"
            >
              <el-option
                v-for="item in receiptInstitutionList"
                :key="item.id"
                :label="item.combination"
                :value="item.accountNo"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('eventList.AccountBank')" prop="bankName">
            <el-input :disabled="true" v-model="formData.bankName" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item :label="$t('eventList.AccountNumber')" prop="bankAccount">
            <el-input :disabled="true" v-model="formData.bankAccount" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('eventList.BranchName')" prop="branchName">
            <el-input :disabled="true" v-model="formData.branchName" />
          </el-form-item>
        </el-col>
      </el-row>
      <div class="title">{{$t('file.Annex')}}</div>
      <el-row>
        <el-col :span="24">
          <el-upload
            ref="upload"
            class="upload-demo"
            :action="baseUrl"
            :on-remove="beforeRemove"
            :before-upload="beforeUpload"
            :on-success="handleSuccess"
            multiple
            :file-list="fileList"
          >
            <el-button size="small" type="primary">{{$t('file.ctu')}}</el-button>
            <div slot="tip" class="el-upload__tip">{{$t('file.F10M')}}</div>
          </el-upload>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogCloseHandle">{{$t('btn.Cancel')}}</el-button>
      <el-button type="primary" @click="submit">{{$t('btn.OK')}}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { activistyCostAttribution } from "../../../service";
export default {
  data() {
    return {
      rules: {
        borrowMoney: [
          {
            required: true,
            message: this.$t("eventList.Pfitla"),
            trigger: "blur"
          }
        ],
        "loanInfo.utilityTime": [
          {
            required: true,
            message: this.$t("eventList.psapd"),
            trigger: "change"
          }
        ],
        borrowPurpose: [
          {
            required: true,
            message: this.$t("eventList.Pfitpi"),
            trigger: "blur"
          }
        ],
        accountType: [
          {
            required: true,
            message: this.$t("eventList.Psaat"),
            trigger: "change"
          }
        ],
        bankAccount: [
          {
            required: true,
            message: this.$t("eventList.Psapu"),
            trigger: "change"
          }
        ]
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      dialogVisible: false,
      formData: {
        loanInfo: {
          utilityTime: "",
          repaymentTime: ""
        },
        reveivable: {}
      },
      baseUrl: "",
      fileList: [],
      payTypeList: [
        // { id: '0', typeName: '现金' },方式写死，现金不走线上
        { id: "1", typeName: this.$t("eventList.BankPayment") }
      ], // 付款方式
      accountTypeList: [
        { id: "1", typeName: this.$t("eventList.InternalStaff") },
        { id: "2", typeName: this.$t("eventList.ExternalUnit") },
        { id: "3", typeName: this.$t("eventList.ExternalInd") }
      ], // 账户类型
      receiptInstitutionList: [], // 收款单位
      loading: false, // 搜索加载效果
      fileUploadStatus: false // 文件上传状态
    };
  },
  props: {
    loanVisible: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    currencyCode: {
      type: String,
      default: ""
    },
    instanceComCode: {
      type: String,
      default: ""
    }
  },
  computed: {},
  components: {},
  watch: {
    loanVisible(val) {
      if (val) {
        this.formData.expenseBelongId = this.rowData.id;
        this.formData.activityCode = this.rowData.activityCode;
        this.formData.deptCode = this.rowData.deptCode;
        this.formData.deptName = this.rowData.deptName;
        this.formData.expenseTypeCode = this.rowData.expenseTypeCode;
        this.formData.expenseType = this.rowData.expenseType;
        this.formData.payType = this.payTypeList[0].typeName;
        this.formData.currencyCode = this.rowData.currencyCode;
        this.formData.instanceComCode = this.rowData.financialSystemCode;
        this.formData.totalCost = this.rowData.applyAmount;
        this.formData.applyUserId = this.rowData.applyUserId;
        this.formData.verifiUserId = this.rowData.applyUserId;
        this.getAnnualInterest(
          this.rowData.deptCode,
          this.rowData.expenseTypeCode
        );
        // 在打开dialog的时候就开始获取文件上传的url，半小时内有效
        this.getFinancialUploadUrl();
        this.$nextTick(() => {
          this.$refs.loanDialogForm.clearValidate();
        });
      }
      this.dialogVisible = val;
    }
  },
  methods: {
    moneyFileter(val) {
      let fileterVal = val
        .replace(/[^\d.]/g, "")
        .replace(".", "$#$")
        .replace(/\./g, "")
        .replace("$#$", ".");
      this.$set(this.formData, "borrowMoney", fileterVal);
    },
    addDay(datetime, days) {
      let oldTime = new Date(datetime.replace(/-/g, "/")); // 替换字符，js不认2013-01-31,只认2013/01/31
      let fd = new Date(oldTime.valueOf() + days * 24 * 60 * 60 * 1000); // 日期加上指定的天数
      let newTime = fd.getFullYear() + "-";
      let month = fd.getMonth() + 1;
      if (month >= 10) {
        newTime += month + "-";
      } else {
        // 在小于10的月份上补0
        newTime += "0" + month + "-";
      }
      if (fd.getDate() >= 10) {
        newTime += fd.getDate();
      } else {
        // 在小于10的日期上补0
        newTime += "0" + fd.getDate();
      }
      return newTime; // 输出格式：2013-01-02
    },
    dialogCloseHandle() {
      this.$emit("dialogCloseHandle");
    },
    submit() {
      this.formData.reveivable.accountType = this.formData.accountType;
      this.formData.reveivable.receivableAmount = this.formData.borrowMoney;
      this.formData.filesInfo = this.fileList.map(item => {
        return {
          fileId: item.response ? item.response.data[0].FID : item.fileId,
          fileName: item.name
        };
      });
      this.$refs["loanDialogForm"].validate(valid => {
        // 触发验证-1.字段信息的验证 2.文件大小的验证
        // 触发文件上传
        if (valid) {
          // this.$refs.upload.submit();开启自动上传
          this.$store.commit("setSubPageLoading", true);
          // todo 2.借款时讲文件作为参数
          activistyCostAttribution.loanSubmit(this.formData).then(res => {
            if (res.status === "200") {
              // 刷新父组件的借款金额
              let rowDataNew = this.rowData;
              rowDataNew.borrowingMoneyTotal =
                Number(this.rowData.borrowingMoneyTotal) +
                Number(this.formData.borrowMoney);
              // 清除数据
              this.formData = {
                loanInfo: {
                  utilityTime: "",
                  repaymentTime: ""
                },
                reveivable: {}
              };
              this.fileList = [];
              this.receiptInstitutionList = [];
              // 借款成功，关掉loading，关掉dialog（更新借款数据）
              this.$message.success(this.$t("general.SuccLoan"));
              this.$emit("dialogSubmitHandle", rowDataNew);
            }
            this.$store.commit("setSubPageLoading", false);
          });
        } else {
          this.$message.error(this.$t("eventList.TaufitliPcc"));
        }
      });
    },
    beforeUpload(file) {
      let fileSize = file.size / 1024 / 1024 < 10;
      if (!fileSize) {
        this.$message.error(this.$t("file.uFn10M"));
      }
      // 赋值文件的验证状态
      this.fileUploadStatus = fileSize;
      return fileSize;
    },
    // 获取费用系统的文件上传链接
    getFinancialUploadUrl() {
      // 其实没有用到同步
      return new Promise((resolve, reject) => {
        // 在传之前获取上传链接
        activistyCostAttribution
          .getFinancialUploadUrl()
          .then(res => {
            if (res.status === "200") {
              this.baseUrl = res.data;
              resolve();
            }
            reject(new Error(this.$t("file.Fuf")));
          })
          .catch(err => {
            reject(new Error(err));
          });
      });
    },
    handleSuccess(res, file, fileList) {
      this.fileList = fileList;
      // 获取到返回的文件id存储入库
      // let attachFileList = [];
      // if (res.status === '200') {
      //   let param = {
      //     activityCode: this.rowData.activityCode,
      //     sourceType: 'Financial',
      //     fileId: res.data[0].FID,
      //     fileName: res.data[0].FullName,
      //     fileSize: file.size
      //   };
      //   attachFileList.push(param);
      //   // 组合请求参数
      //   // todo 1.先获取文件上传后的文件信息（fid,fname）
      //   activistyCostAttribution.saveFinancialFile(attachFileList).then(res => {
      //     if (res.status !== '200') {
      //       this.$message.error('文件存储失败');
      //     }
      //   }).catch(err => {
      //     this.$message.error('文件存储失败', err);
      //   });
      // } else {
      //   this.$message.error('文件上传失败');
      // }
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        this.$t("file.Limit1") +
          files.length +
          this.$t("file.Limit2") +
          (files.length + fileList.length) +
          this.$t("file.Limit3")
      );
    },
    beforeRemove(file, fileList) {
      if (file && file.status === "success") {
        this.$message({
          type: "success",
          message: this.$t('general.DeleSucc')
        });
      }
    },
    getAnnualInterest(deptCode, expenseTypeCode) {
      activistyCostAttribution
        .getAnnualInterest({ deptCode, expenseTypeCode })
        .then(res => {
          if (res.status === "200") {
            this.$set(this.formData, "annualInterest", res.data.perValShow);
          }
        });
    },
    getFinancialAccountByKey(keyWord) {
      this.loading = true;
      // 不为空时才调用
      if (keyWord && this.formData.accountType) {
        let params = {
          accountType: this.formData.accountType,
          keyWord: keyWord
        };
        // encodeURIComponent(keyWord) // encodeURIComponent将字符串转换为uri编码
        activistyCostAttribution.getFinancialAccountByKey(params).then(res => {
          if (res.status === "200") {
            this.loading = false;
            this.receiptInstitutionList = res.data.map(item => {
              return {
                ...item,
                combination: `${item.accountName}/${item.accountNo}`
              };
            });
          }
        });
      }
    },
    // 计算还款日期
    clickUseDate(date) {
      // 还款日期在用款日期后的90天 运娇表述：2021/01/27
      let repaymentTime = this.addDay(date, 90);
      this.$set(this.formData.loanInfo, "repaymentTime", repaymentTime);
    },
    receiptInstitutionChange(bankAccount) {
      // 组合formData.reveivable
      let receObj = this.arrayQuery(
        bankAccount,
        this.receiptInstitutionList,
        "accountNo"
      );
      this.$set(this.formData, "reveivable", receObj);
      this.$set(
        this.formData.reveivable,
        "receiptInstitution",
        receObj.combination
      );
      // 用于页面显示开户信息
      this.$set(this.formData, "bankName", receObj.bankName);
      this.$set(this.formData, "branchName", receObj.branchBankName);
    },
    arrayQuery(val, list, findKey) {
      return list.find(item => {
        return item[findKey] === val;
      });
    }
  },
  mounted() {}
};
</script>

<style lang="scss" scoped>
.loanDialog {
  .el-form {
    .danger {
      color: #ed1940;
    }
    .especial {
      color: #3384fe;
      ::v-deep > .el-form-item__label:before {
        content: "*";
        margin-right: 4px;
        color: #f56c6c;
      }
    }
    .title {
      font-weight: bold;
      margin: 20px 0;
    }
  }
}
</style>
